<template>
  <div
    class="mt-4 flex w-full flex-col gap-2 self-start rounded bg-white p-6 drop-shadow-lg sm:max-w-[481px] md:self-end lg:p-10"
  >
    <template v-if="gift?.discountPercentage">
      <h1
        class="text-teal-primary text-2xl font-semibold tracking-wide md:text-3xl lg:text-[32px]"
      >
        Exclusive Savings on Eyewear
      </h1>
      <h3 class="text-grays-dark">
        Shop Zenni’s top styles for less with your
        {{ gift?.storeName }} discount.
      </h3>
    </template>
    <template v-else>
      <h1
        class="text-teal-primary text-2xl font-semibold tracking-wide md:text-3xl lg:text-[32px]"
      >
        Discover Your Signature Style
      </h1>
      <h3 class="text-grays-dark">
        Shop Zenni’s top styles for {{ gift?.storeName }}.
      </h3>
    </template>
  </div>
</template>
<script setup lang="ts">
import { storeToRefs } from '#imports'
import { useGuestStore } from '~/store/guest'

const { gift } = storeToRefs(useGuestStore())
</script>
